export default __webpack_public_path__ + "static/media/schema.831fc70b.png";